import { render, staticRenderFns } from "./create-package.html?vue&type=template&id=0082066a&scoped=true&external"
import script from "./create-package.js?vue&type=script&lang=js&external"
export * from "./create-package.js?vue&type=script&lang=js&external"
import style0 from "./create-package.scss?vue&type=style&index=0&id=0082066a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0082066a",
  null
  
)

export default component.exports